export default "__VITE_ASSET__e1c38348__"